import { FC } from 'react';

import { Transaction } from '@ravago/shared/page-data/models/elements';

import { OpenInvoiceCard } from './open-invoice-card';

type Props = {
   currency: string;
   invoices: Transaction[];
   canPayOnline: boolean;
   selectedInvoiceIds: string[];
   onInvoiceSelect: (invoiceId: string) => void;
   onInvoiceDeselect: (invoiceId: string) => void;
};

export const OpenInvoiceTableMobile: FC<Props> = ({ currency, invoices, canPayOnline, selectedInvoiceIds, onInvoiceSelect, onInvoiceDeselect }) =>
   invoices.map((invoice, index) => (
      <OpenInvoiceCard
         // eslint-disable-next-line @eslint-react/no-array-index-key
         key={index}
         currency={currency}
         invoice={invoice}
         canPayOnline={canPayOnline}
         selected={selectedInvoiceIds.includes(invoice.id)}
         onSelect={() => onInvoiceSelect(invoice.id)}
         onDeselect={() => onInvoiceDeselect(invoice.id)}
      />
   ));
